var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',{attrs:{"cols":"12","elevation":"0"}},[_c('v-col',[_c('v-row',{domProps:{"innerHTML":_vm._s(_vm.article)}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }